
import { useEffect } from "react";
import { ProductCard } from "./ProductCard";
import { CreateProductCard } from "./CreateProductCard";
import { useProducts } from "@/hooks/useProducts";
import { useAdminAuth } from "@/hooks/useAdminAuth";

export const ProductsGrid = () => {
  const { products, isLoading, fetchProducts, handleDelete } = useProducts();
  useAdminAuth();

  useEffect(() => {
    fetchProducts();
  }, []);

  if (isLoading) {
    return <div className="text-center py-12">Loading products...</div>;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          {...product}
          onDelete={handleDelete}
          onUpdate={fetchProducts}
          product_screen={product.product_screen || ""}
        />
      ))}
      <CreateProductCard />
    </div>
  );
};
